/**
 * Admin Components Exports
 *
 * @since 1.0.0
 */

export { GlobalTabs } from './global-tabs';
export { Navigation } from './navigation';
export { NotificationsContainer } from './notifications-container';
export { SidebarFooter } from './sidebar-footer';
export { TabList } from './tab-list';
export { TabManagerApp } from './tab-manager-app';

// Re-export global-tabs components
export { GlobalTabsManager, TabItemRenderer, TabModal } from './global-tabs/components';
